(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["proxy-exclusive-fan-club"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'proxy-hotties-fan-club-username-v1';
    const maxRememberAge = 30 * 24 * 60 * 60 * 1000;
    function init(root) {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const form = root.querySelector('[data-username-form]');
      const input = form.querySelector('input[name="discord_username"]');
      const submit = root.querySelector('[data-submit]');
      const status = root.querySelector('[data-status]');
      const listings = root.querySelector('[data-listings]');
      const gate = root.querySelector('[data-gate]');
      const productTemplate = root.querySelector('[data-product-template]');
      const productContent = root.querySelector('[data-product-content]');
      const welcomeTemplate = root.querySelector('[data-welcome-template]');
      const welcomeContent = root.querySelector('[data-welcome-content]');
      if (!root.dataset.backend) { submit.disabled = true; return; }
      let generation = 0;
      let controller;
      const forget = () => { try { localStorage.removeItem(storageKey); } catch {} };
      const remember = username => { try { localStorage.setItem(storageKey, JSON.stringify({ username, expiresAt: Date.now() + maxRememberAge })); } catch {} };
      function savedUsername() {
        try {
          const saved = JSON.parse(localStorage.getItem(storageKey));
          if (typeof saved?.username === 'string' && saved.username.length <= 64 && saved.expiresAt > Date.now() && saved.expiresAt <= Date.now() + maxRememberAge + 60000) return saved.username;
        } catch {}
        forget();
        return null;
      }
      function listingPage() {
        const parameters = new URL(window.location.href).searchParams;
        let value = parameters.get('club_page');
        if (value === null) {
          for (const [key, entry] of parameters) {
            if (key.startsWith('page_')) { value = entry; break; }
          }
        }
        const page = Number(value);
        return Number.isInteger(page) && page > 0 ? page : 1;
      }
      function renderListingPage(requestedPage) {
        const grid = productContent?.querySelector('[data-paged-grid]');
        if (!grid) return;
        const cards = Array.from(productContent.querySelectorAll('template[data-card-template]'));
        const pageCount = Math.max(1, Math.ceil(cards.length / 24));
        const page = Math.min(Math.max(1, requestedPage), pageCount);
        grid.replaceChildren(...cards.slice((page - 1) * 24, page * 24).map(card => card.content.cloneNode(true)));
        const empty = productContent.querySelector('[data-empty-listings]');
        if (empty) empty.hidden = cards.length > 0;
        const navigation = productContent.querySelector('[data-card-pagination]');
        navigation.replaceChildren();
        navigation.hidden = pageCount < 2;
        for (let number = 1; number <= pageCount; number++) {
          const link = document.createElement('a');
          const url = new URL(window.location.href);
          for (const key of Array.from(url.searchParams.keys())) {
            if (key.startsWith('page_')) url.searchParams.delete(key);
          }
          url.searchParams.set('club_page', String(number));
          link.href = url.href;
          link.dataset.clubPage = String(number);
          link.textContent = String(number);
          if (number === page) link.setAttribute('aria-current', 'page');
          navigation.append(link);
        }
      }
      productContent?.addEventListener('click', event => {
        const link = event.target.closest('a[data-club-page]');
        if (!link || listings.hidden || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        history.replaceState(null, '', link.href);
        renderListingPage(Number(link.dataset.clubPage));
        root.querySelector('.ph-club__listings-header').scrollIntoView({ block: 'start' });
      });
      async function check(username) {
        const ticket = ++generation;
        controller?.abort();
        const requestController = new AbortController();
        controller = requestController;
        const timeout = setTimeout(() => requestController.abort(), 15000);
        listings.hidden = true;
        gate.hidden = false;
        submit.disabled = true;
        status.textContent = root.dataset.checking;
        try {
          const backend = new URL(root.dataset.backend);
          if (backend.protocol !== 'https:' || backend.pathname !== '/' || backend.search || backend.hash || backend.username || backend.password) throw new Error('backend');
          const res = await fetch(backend.origin + '/check', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ username }), credentials: 'omit', cache: 'no-store', signal: requestController.signal
          });
          const data = await res.json();
          if (ticket !== generation) return;
          if (!res.ok) {
            status.textContent = res.status === 429 ? root.dataset.rateLimited : res.status === 400 ? root.dataset.invalid : root.dataset.unavailable;
            return;
          }
          if (data.member === true) {
            if (productTemplate && productContent && !productContent.hasChildNodes()) productContent.append(productTemplate.content.cloneNode(true));
            renderListingPage(listingPage());
            if (welcomeTemplate && welcomeContent && !welcomeContent.hasChildNodes()) welcomeContent.append(welcomeTemplate.content.cloneNode(true));
            listings.hidden = false;
            gate.hidden = true;
            status.textContent = root.dataset.success;
            remember(username.trim());
          } else if (data.member === false) {
            forget();
            status.textContent = root.dataset.denied;
          } else {
            status.textContent = root.dataset.unavailable;
          }
        } catch {
          if (ticket === generation) status.textContent = root.dataset.unavailable;
        } finally {
          clearTimeout(timeout);
          if (ticket === generation) submit.disabled = false;
        }
      }
      form.addEventListener('submit', event => {
        event.preventDefault();
        const username = input.value.trim();
        if (username.length < 2 || username.length > 64) { status.textContent = root.dataset.invalid; return; }
        void check(username);
      });
      root.querySelector('[data-reset]').addEventListener('click', () => {
        ++generation;
        controller?.abort();
        forget();
        listings.hidden = true;
        productContent?.replaceChildren();
        welcomeContent?.replaceChildren();
        gate.hidden = false;
        submit.disabled = false;
        status.textContent = '';
        input.value = '';
        input.focus();
      });
      const saved = savedUsername();
      if (saved) { input.value = saved; void check(saved); }
    }
    document.querySelectorAll('[data-ph-club]').forEach(init);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ph-club]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();
})();
